
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.057 7.18c.01.212.01.413.01.625.009 6.403-4.696 13.795-13.3 13.795C5.23 21.6 2.74 20.84.6 19.42a9.174 9.174 0 006.918-2.016c-2-.038-3.76-1.391-4.371-3.369a4.366 4.366 0 002.111-.086c-2.176-.442-3.741-2.43-3.75-4.743V9.15c.648.374 1.38.585 2.12.604-2.046-1.42-2.685-4.252-1.444-6.47 2.38 3.034 5.88 4.867 9.64 5.069a4.98 4.98 0 011.352-4.637c1.88-1.834 4.844-1.738 6.621.211a9.093 9.093 0 002.973-1.18 4.855 4.855 0 01-2.056 2.678 9.363 9.363 0 002.686-.759 9.77 9.77 0 01-2.343 2.516z","fill":"#fff"}})])
          )
        }
      }
    